module.exports = "<app-visit-report [requestType]=\"requestType\" [title]=\"title\"></app-visit-report>"